import { mutator } from 'satcheljs';
import updateCalendarProcessingOptions from '../../actions/updateCalendarProcessingOptions';
import getCalendarOptions from '../../utils/getCalendarOptions';
var assign = require('object-assign');
/**
 * Update calendar processing options in store
 */
export default mutator(updateCalendarProcessingOptions, function (actionMessage) {
    assign(getCalendarOptions(), actionMessage.calendarProcessingOptions);
});
//# sourceMappingURL=updateCalendarProcessingOptionsMutator.js.map